import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape } from 'react-intl';
import s from './CarDriveInfo.css';

const MAX_COUNT = 90;

class CarDriveInfo extends React.PureComponent {
  static propTypes = {
    carDriveInfo: PropTypes.string.isRequired,
    carDriveCountries: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    //
    intl: intlShape.isRequired,
  };

  state = {
    collapseCountries: true,
    collapseInfo: true,
  };

  fixText = (text, collapse) =>
    text.length > MAX_COUNT && collapse ? text.slice(0, MAX_COUNT) : text;

  render() {
    const { carDriveInfo, carDriveCountries, intl } = this.props;
    const { collapseCountries, collapseInfo } = this.state;

    const arrCountriesTitles = carDriveCountries
      .map((item, i) => `${item.title}${carDriveCountries.length !== i + 1 ? ', ' : ''}`)
      .join('');

    return (
      <div>
        <div className={s.infoSection}>
          <span className={s.infoTitle}>{intl.formatMessage({ id: 'Страны' })}: </span>
          <span>{this.fixText(arrCountriesTitles, collapseCountries)}</span>
          {arrCountriesTitles.length > MAX_COUNT && collapseCountries && (
            <span onClick={() => this.setState({ collapseCountries: false })} className={s.dots}>
              {' '}
              ...
            </span>
          )}
        </div>
        <div className={s.infoSection}>
          <span className={s.infoTitle}>{intl.formatMessage({ id: 'Условия пригона' })}: </span>
          <span>{this.fixText(carDriveInfo, collapseInfo)}</span>
          {carDriveInfo.length > MAX_COUNT && collapseInfo && (
            <span onClick={() => this.setState({ collapseInfo: false })} className={s.dots}>
              {' '}
              ...
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(CarDriveInfo));



// WEBPACK FOOTER //
// ./src/shared/components/CarDriveInfo/CarDriveInfo.js